export enum DOCUMENT_TYPES {
  //Faktury
  VATInvoice = 1,
  VATInvoiceCorrection = 2,
  VATInvoiceMargin = 3,
  VATInvoiceMarginCorrection = 4,
  InvoiceOnBehalfOfAndFor = 5,
  InvoiceOnBehalfOfAndForCorrection = 6,
  DebitCreditNote = 7,
  DebitCreditNoteCorrection = 8,
  ReceiptDocuments = 9,
  PkpIntercityNote = 10,

  CorrectionNote = 20,

  RequestForPayment = 30,
  InterestNote = 31,

  CashReport = 40,
  CashIn = 41,
  CashOut = 42,

  //Faktury zaliczkowe
  AdvanceInvoice = 50,
  AdvanceInvoiceCorrection = 51,
  AdvanceInvoiceOnBehalfOfAndFor = 52,
  AdvanceInvoiceOnBehalfOfAndForCorrection = 53,
  AdvanceInvoiceVatMargin = 54,
  AdvanceInvoiceVatMarginCorrection = 55,
  AdvanceInvoiceVatMarginFinish = 56,
  AdvanceInvoiceVatMarginFinishCorrection = 57,
  AdvanceInvoiceFinish = 60,
  AdvanceInvoiceFinishCorrection = 61,
  AdvanceInvoiceOnBehalfOfAndForFinish = 62,
  AdvanceInvoiceOnBehalfOfAndForFinishCorrection = 63,

  //Proformy
  ProformaInvoice = 80,
  ProformaInvoiceCorrection = 81,
  ProformaInvoiceMargin = 82,
  ProformaInvoiceMarginCorrection = 83,
  ProformaInvoiceOnBehalf = 84,
  ProformaInvoiceOnBehalfCorrection = 85,
  ProformaAdvanceInvoiceFinish = 86,
  ProformaAdvanceInvoiceVatMarginFinish = 87,
  ProformaAdvanceInvoiceOnBehalfOfAndForFinish = 88,

  InternalDocument = 90,
  DuplicateDocument = 91,

  InvoicePreview = 100,

  //Wyciągi bankowe  - integracja z optimą
  BankStatement = 110,
  BankStatementItemKP = 111,
  BankStatementItemKW = 112,

  //Wyciągi kart kredytowych
  CreditCardStatement = 120,
  CreditCardStatementItemKP = 121,
  CreditCardStatementItemKW = 122,

  //Voucher
  Voucher = 130,

  ProtocolReturnToReceipt = 140,
  RecordsOfMistake = 141,

  TouristContract = 150,

  //Kosztówki
  CostDocument = 160,
  CostDocumentCorrection = 161,
  CostVoucher = 162,

  CostDocumentWithVAT = 170,
  CostDocumentWithoutVAT = 171,
}
